import React, { useEffect, useState } from "react";
import { api_url } from "../../helpers/apiHelpers";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const PensionProposalPrint = () => {
  const navigate = useNavigate();
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const [PensionProposalData, setPensionProposalData] = useState([]);
  const getPensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);

        setPensionProposalData(singleData);
      } else {
        setPensionProposalData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getPensionProposalData();
  }, [userId]);
  const [formData, setFormData] = useState([]);
  const [familyMember, setfamilyMember] = useState([]);
  useEffect(() => {
    try {
      if (PensionProposalData?.formData) {
        setFormData(JSON.parse(PensionProposalData.formData));
      }
      if (PensionProposalData?.familyMember) {
        setfamilyMember(JSON.parse(PensionProposalData.familyMember));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [PensionProposalData]);

  const [serviceDurationYears, ServiceDurationYears] = useState(0);
  const [serviceDurationMonth, setServiceDurationMonth] = useState(0);
  // Update the home rent whenever formData changes
  useEffect(() => {
    // Function to extract years (वर्ष) as a string
    const getYears = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const yearsPart = parts.find((part) => part.includes("वर्ष")); // Find the part with "वर्ष"

        if (yearsPart) {
          // Extract the number before "वर्ष" using regex
          const match = yearsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }
      }

      return null; // Return null if "वर्ष" is not found
    };
    const getMonths = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const monthsPart = parts.find((part) => part.includes("महिने")); // Find the part with "महिने"

        if (monthsPart) {
          // Extract the number before "महिने" using regex
          const match = monthsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }

        return null; // Return null if "महिने" is not found
      }
    };

    // Example usage:
    const months = getMonths(formData && formData.serviceDuration);

    const years = getYears(formData && formData.serviceDuration);
    setServiceDurationMonth(
      months >= 3 && months < 9 ? 1 : months >= 9 && months < 12 ? 2 : 0
    );

    const result = getYears(formData.serviceDuration);
    ServiceDurationYears(result); // Output: "4 वर्ष"
  }, [formData.serviceDuration]);

  const [serviceDurationMonth1, setServiceDurationMonth1] = useState(0);

  useEffect(() => {
    setServiceDurationMonth1(
      serviceDurationYears > 33
        ? Math.round(33 * 2)
        : Math.round(serviceDurationYears * 2 + serviceDurationMonth)
    );
  }, [
    formData.birthDateNumber,
    formData.appointmentDate,
    formData.retirementDate,
    serviceDurationYears,
    serviceDurationMonth,
  ]);

  const generatePrintablePage = async () => {
    // Add dynamic CSS for proper page breaks and consistent layout
    const style = document.createElement("style");
    style.innerHTML = `
      /* General styling */
      * {
        padding: 0px !important;
        margin: 0px !important;
        font-size: 14px !important;
        color: #000 !important;
        box-sizing: border-box; /* Maintain consistent sizing */
      }
        .commonClassTable{
        margin: 0px 0 !important;
        width:100% !important;
      }
      #pension-proposal-print {
        width: 100%;
      }
      .commonClassTable .highlight {
        background-color: yellow !important;
      }
      table th,table td{
        padding: 2px 5px !important;
        
      }
        .tableHeading,tableHeading1{
        font-size:12px !important;}
        
      /* Ensure each section prints on its own page */
      #pension-proposal-print > div {
        page-break-after: always; /* Force each child div to print on a new page */
        page-break-inside: avoid; /* Avoid breaking inside sections */
      }
      

      /* Page setup */
      @page {
        size: A4; /* Set the page size to A4 */
        margin: 10mm 10mm 10mm 10mm !important; /* Set page margin */
      }
  
      @media print {
        body {
          margin: 0;
          padding: 0;
        }
  
        /* Hide unnecessary sections like buttons */
        #button-section {
          display: none;
        }
      }
    `;
    document.head.appendChild(style);

    // Get the #inter-district-transfer-print element
    const printContent = document.getElementById("pension-proposal-print");

    if (printContent) {
      // Clone the content for printing
      const printWrapper = document.createElement("div");
      printWrapper.id = "print-wrapper";

      // Clone each child element of #inter-district-transfer-print
      Array.from(printContent.children).forEach((child) => {
        const clone = child.cloneNode(true);
        printWrapper.appendChild(clone);
      });

      // Append the cloned content to the body
      document.body.appendChild(printWrapper);

      // Trigger the print dialog
      window.print();

      // Clean up after printing
      document.body.removeChild(printWrapper);
      document.head.removeChild(style);
    } else {
      alert("No content available for printing.");
    }
  };
  return (
    <div className="container-xl py-3">
      <div className="row my-4" id="button-section">
        <div className="col-lg-4">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/dashboard/pension_proposal")}
          >
            Back
          </button>
        </div>
      </div>
      <div id="pension-proposal-print" className="pension-proposal-print mt-3">
        <div id="section1" className="border px-3 py-5">
          <h3 class="text-center highlight py-3 border">
            निवृत्ती वेतन परिगणना पत्रक
          </h3>
          <table class="table table-borderless mt-3">
            <tbody>
              <tr>
                <th>1</th>
                <th>कर्मचाऱ्यांचे नाव</th>
                <th>:-</th>
                <th>{formData && formData.fullName}</th>
              </tr>
              <tr>
                <th>2</th>
                <th>निवृत्ती वेतन च्या धारण केलेल्या पदाचे नाव </th>
                <th>:-</th>
                <th>{formData && formData.designation}</th>
              </tr>
              <tr>
                <th>3</th>
                <th>अखेरीस काम करीत असलेले कार्यालय </th>
                <th>:-</th>
                <th>{formData && formData.officeName}</th>
              </tr>
              <tr>
                <th></th>
                <th>Sevarth ID</th>
                <th>:-</th>
                <th>{formData && formData.sevarthID}</th>
              </tr>
              <tr>
                <th>4</th>
                <th>जन्मतारीख अहारी व अंकात</th>
                <th>:-</th>
                <th>
                  {formData && formData.birthDateNumber},{" "}
                  {formData && formData.birthDateWords}
                </th>
              </tr>
              <tr>
                <th>5</th>
                <th>सेवा निवृत्तीची तारीख</th>
                <th>:-</th>
                <th>{formData && formData.retirement}</th>
              </tr>
              <tr>
                <th>6</th>
                <th>कोणत्या नियमानुसार निवृत्ती वेतन विषयक लाभ </th>
                <th>:-</th>
                <th>महाराष्ट्र नागरी सेवा (निवृत्तीवेतन) १९८२</th>
              </tr>
              <tr>
                <th></th>
                <th>नियुक्तीच्या वेळी असलेले वय</th>
                <th>:-</th>
                <th>{formData && formData.ageOnRetirement}</th>
              </tr>
              <tr>
                <th>7</th>
                <th>
                  निवृत्तीवेतनासाठी अहर्ताकारी सेवेचे कालावधी खालील गोष्टी
                  वेगवेगळ्या दाखवाव्यात :
                  <p className="fw-normal">
                    <small>
                      १ अहर्ताकारी सेवेतील भर उदा मनासे निवृत्तीवेतन नियम ५३
                      अनुसार आणि
                    </small>
                  </p>
                  <p className="fw-normal">
                    <small>
                      २ अहर्ताकारी सेवेचा कालावधी अहर्ताकारी म्हणून धरण्याची
                      कारणे प्रत्येकासमोर दर्शवावीत
                    </small>
                  </p>
                </th>
                <th style={{ verticalAlign: "middle" }}>:-</th>
                <th style={{ verticalAlign: "middle" }}>
                  {formData && formData.serviceDuration}
                </th>
              </tr>
              <tr>
                <th>8</th>
                <th>
                  सेवा निवृत्तीच्यावेळी जमसे धरलेले शेवटच्या महिन्य
                  <p className="fw-normal">
                    <small>
                      वेतन श्रेणीसह विषश वेतन प्रतिनियुक्ती भत्ता वैयक्तीक वेतन
                      महागाई वेतन , अतिरिक्त वाढ इत्यादीसह (मूळवेतन )
                    </small>
                  </p>
                </th>
                <th style={{ verticalAlign: "middle" }}>:-</th>
                <th style={{ verticalAlign: "middle" }}>
                  {formData && formData.baseSalary}
                </th>
              </tr>
              <tr>
                <th>9</th>
                <th>प्रस्तावित सेवा निवृत्ती वेतन</th>
                <th>:-</th>
                <th>
                  {formData && formData.baseSalary} * 50% ={" "}
                  {formData && formData.baseSalary * 0.5}
                </th>
              </tr>
              <tr>
                <th>10</th>
                <th>प्रस्तावित कुटुंब निवृत्ती वेतन</th>
                <th>:-</th>
                <th>
                  {" "}
                  {formData && formData.baseSalary} * 30% ={" "}
                  {formData && formData.baseSalary * 0.3}
                </th>
              </tr>
              <tr>
                <th>11</th>
                <th>मृत्यु नि सेवा उपदानाची रक्कम</th>
                <th>:-</th>
                <th>
                  {formData && formData.baseSalary} * {serviceDurationYears * 2}{" "}
                  ={" "}
                  {formData &&
                    (formData.baseSalary * serviceDurationYears * 2) / 4}
                </th>
              </tr>
              <tr>
                <th>12</th>
                <th>अंशदान निवृत्ती वेतन</th>
                <th>:-</th>
                <th>
                  {formData && formData.baseSalary * 0.5} * 40 / 100 =
                  {Math.round(
                    formData && (formData.baseSalary * 0.5 * 40) / 100
                  )}
                </th>
              </tr>
              <tr>
                <th>13</th>
                <th>अंशराशीकरणाची देय रक्कम</th>
                <th>:-</th>
                <th>
                  {Math.round(
                    formData && (formData.baseSalary * 0.5 * 40) / 100
                  )}{" "}
                  * {formData && formData.contributionValueAmt} * 12 =
                  {Math.round(
                    formData &&
                      ((formData.baseSalary * 0.5 * 40) / 100) *
                        formData.contributionValueAmt *
                        12
                  )}
                </th>
              </tr>
              <tr>
                <th>14</th>
                <th>अंशराशीकरण वजा जाता देय निवृत्ती वेतन</th>
                <th>:-</th>
                <th>
                  {Math.round(formData && formData.baseSalary * 0.5)} *{" "}
                  {Math.round(
                    formData && (formData.baseSalary * 0.5 * 40) / 100
                  )}{" "}
                  / 100 ={" "}
                  {Math.round(
                    formData &&
                      (formData.baseSalary *
                        0.5 *
                        (formData.baseSalary * 0.5 * 40)) /
                        100 /
                        100
                  )}
                </th>
              </tr>

              <tr>
                <th>15</th>
                <th>जादा अदाईची वसुली</th>
                <th>:-</th>
                <th className="border">0</th>
              </tr>
              <tr>
                <th>16</th>
                <th>गट विमा योजनेचे गृहकर्ज वसुली</th>
                <th>:-</th>
                <th className="border"> 0</th>
              </tr>
              <tr>
                <th>17</th>
                <th>एकूण वसुलपात्र रक्कम</th>
                <th>:-</th>
                <th className="border">0</th>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="section2" className="commonClassTable border px-3 py-4">
          <h3 class="text-center highlight py-3 border mb-2">परिशिष्ट पाच</h3>
          <h3 class="text-center my-2">(नमुना-1)</h3>
          <h3 class="text-center mb-2">(नियम ११५ (१) पहा)</h3>

          <p class="adrnie text-center fw-bold">
            सेवानिवृत्ती उपदान /मृत्यु उपदानाकरीता नामनिर्दे शित शासकिय
            कर्मचा-याला कुटुंब असेल आणि <br />
            त्यापैको एका किंवा एका पेक्षा अधिक सदस्यास नामनिर्दे शित करण्याची
            इच्छा असेल तेव्हा
          </p>
          <p class="mt-2 textIndent">
            मी <b>{formData && formData.fullName}</b>,{" "}
            <b>{formData && formData.designation}</b>,{" "}
            <b>{formData && formData.officeName}</b> या व्दारे खालील निर्दिष्टीत
            केलेल्या माझे कुटुंबातील सदस्याला / सदस्यांना नामनिर्देशित करीत आहे.
            आणि सेवेत असतांना माझा मृत्यू झाल्यास महाराष्ट्र शासनाकडून मंजूर
            करण्यात येईल असे खाली विनिर्दिष्ठ केलेल्या मर्यादेपर्यंतचे उपदान
            स्विकारण्याचा अधिकार आणि सेवा निवृत्तीनतर माझा मृत्यू झाल्यास
            त्यावेळी अदत राहील असे अनुज्ञेय झालेले खाली विनिर्दिष्ठ केलेल्या
            मर्यादेपर्यंत उपदान स्विकारण्याचा अधिकार त्याला त्यांना प्रदान करीत
            आहे.
          </p>

          <table class="table table-bordered text-center mt-2">
            <thead className="tableHeading1">
              <tr>
                <th>नामनिर्देशित केलेल्या सदस्याचे नाव</th>
                <th>शासकिय कर्मचाऱ्यांशी नाते.</th>
                <th>वय</th>
                <th>
                  <small>
                    सदस्याला देय असलेली उपदानाची रक्कम किंवा त्याचा हिस्सा{" "}
                  </small>
                </th>
                <th>
                  <small className="tableHeading">
                    नामनिर्देशित सदस्य हा शासकिय कर्मचाऱ्याच्या अगोदर मृत्यू
                    पावल्यास किंवा शासकिय कर्मचाऱ्याच्या मृत्यू नंतर उपदानाची
                    रक्कम प्राप्त होण्यापूर्वी मृत्यू पावला तर त्या बाबत
                    नामनिर्देशित सदस्याला प्रदान
                  </small>
                </th>
                <th>प्रत्येक सदस्याला देय असलेली उपदानाची रक्कम किंवा</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>2 </td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
                <td>6</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>{familyMember && familyMember[0]?.nameMr}</td>
                <td>{familyMember && familyMember[0]?.relation}</td>
                <td>{familyMember && familyMember[0]?.age}</td>
                <td>100%</td>
                <td>
                  <ul>
                    <li>{familyMember && familyMember[1]?.nameMr}</li>
                    <li>{familyMember && familyMember[2]?.nameMr}</li>
                  </ul>
                </td>
                <td>समान हिस्सा</td>
              </tr>
            </tbody>
          </table>
          <div className="d-flex justify-between align-items-center">
            <p class="text-start">या नामनिर्देशनामुळे यापूर्वी दिनांक :-</p>
            <p class="">रोजी केलेले नामनिर्देशन रद्द ठरले आहे.</p>
          </div>
          <div className="row mt-3 align-items-center">
            <div className="col-lg-8 col-8 col-md-8"></div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold">{formData && formData.fullName}</p>
              <p className="fw-bold">{formData && formData.designation}</p>
              <p className="fw-bold">{formData && formData.officeName}</p>
            </div>
          </div>

          <table class="table table-borderless my-2">
            <thead>
              <tr>
                <th colSpan={2}>साक्षीदाराचे नाव व स्वाक्षरी </th>
              </tr>
              <tr>
                <th>1) स्वाक्षरी :- __________________________________</th>
                <th>2) स्वाक्षरी :- __________________________________</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>नांव :- _________________________________________</td>
                <td>नांव :- _________________________________________</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>पद नाम :- ______________________________________</td>
                <td>पद नाम :- ______________________________________</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>कार्यालय :- _____________________________________</td>
                <td>कार्यालय :- _____________________________________</td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex justify-content-evenly align-items-center pt-3 mt-3">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>

          <h4 class="text-center bg-secondary text-white highlight py-2 border mt-3 mb-2">
            (कार्यालय प्रमुख / लेखा परिक्षा अधिकारी यांनी भरावयाचे )
          </h4>

          <div>
            <p class="pt-2">
              नामनिर्देशित करणा-या व्यक्तीचे नाव :{" "}
              <b className="fw-bold">
                {formData && formData.fullName},{" "}
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>
            </p>
          </div>

          <p className="fw-bold mt-2">
            ठिकाण :- {formData && formData.officeName}
          </p>
          <p className="fw-bold mt-2">दिनांक :-</p>
          <div class="d-flex justify-content-evenly align-items-center pt-4 mt-4">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>
        </div>

        <div id="section3" className="commonClassTable border px-3 py-5">
          <h3 class="text-center highlight py-3 border mb-2">परिशिष्ट पाच</h3>
          <h3 class="text-center mb-2">नमुना (३)</h3>
          <h3 class="text-center mb-2">(नियम ११६ (१४) पहा)</h3>

          <table className="table table-borderless border-0 mt-3 w-50 m-auto">
            <tbody>
              <tr>
                <th className="ps-3">शासकीय कर्मचा-याचे नाव </th>
                <th className="w-4">:-</th>
                <th className="ps-3">{formData && formData.fullName}</th>
              </tr>
              <tr>
                <th className="ps-3">पदनाम </th>
                <th className="w-4">:-</th>
                <th className="ps-3">{formData && formData.designation}</th>
              </tr>
              <tr>
                <th className="ps-3">जन्मदिनांक </th>
                <th className="w-4">:-</th>
                <th className="ps-3">{formData && formData.birthDateNumber}</th>
              </tr>
              <tr>
                <th className="ps-3">प्रथम नेमणुक दिनांक </th>
                <th className="w-4">:-</th>
                <th className="ps-3">{formData && formData.appointmentDate}</th>
              </tr>
              <tr>
                <th className="ps-3">सेवानिवृत्ती दिनांक </th>
                <th className="w-4">:-</th>
                <th className="ps-3">{formData && formData.retirementDate}</th>
              </tr>
            </tbody>
          </table>

          <p class="fw-bold text-center mt-5">
            माझ्या कुटुंबात असलेल्या सदस्यांचा तपशिल
          </p>

          {/* <table class="table table-bordered"> */}

          <div class=" mt-3">
            <table class="table table-bordered text-sm">
              <thead>
                <tr class="table-heading">
                  <th>अ.क्र</th>
                  <th>कुटुंबातील सदस्याचे नाव</th>
                  <th>जन्मतारीख</th>
                  <th>कर्मचाऱ्याशी नाते</th>
                  <th>विवाहित/अविवाहित</th>
                  <th>कार्यालय प्रमुखाची सही </th>
                  <th className="w-48 text-center">शेरा</th>
                </tr>
              </thead>
              <tbody>
                {familyMember.map((row, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{row.nameMr}</td>
                    <td>{row.dob && moment(row.dob).format("DD-MMM-YYYY")}</td>
                    <td>{row.relation}</td>
                    <td>{row.maritalStatus}</td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p class="textIndent pt-2">
            वरील तपशीलात कोणताही भर पडल्यास किंवा फेरबदल झाल्यास त्याची माहिती
            कार्यालय प्रमुखास / लेखापरिक्षण अधिका-यास कळवून हा तपशील अदयावत
            ठेवण्याची मी या द्वारे हमी देत आहे
          </p>

          <div className="row mt-4 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold">
                स्थळ :-{" "}
                <label className="text-danger fw-bold">
                  {formData && formData.officeName}
                </label>
              </p>
              <p className="fw-bold">दिनांक :-</p>
            </div>
          </div>

          <div class="row mt-5 signatureText">
            <div class="col-lg-4 col-4 text-center">
              <p>
                <b>
                  {formData && formData.fullName},
                  {formData && formData.designation}
                </b>
              </p>
              <p>
                <b>{formData && formData.officeName}</b>
              </p>
            </div>
            <div class="col-lg-4 col-4 text-center">
              <p>
                <b>
                  {formData && formData.officerDesignation} <br />
                  {formData && formData.officeName}
                </b>
              </p>
            </div>
            <div class="col-lg-4 col-4 text-center">
              <p>
                <b>
                  {formData && formData.hodDesignation}
                  <br />
                  {formData && formData.currentDistrict}
                </b>
              </p>
            </div>
          </div>
        </div>

        <div id="section4" className="commonClassTable border px-3 py-5">
          <h3 class="text-center highlight py-3 border mb-2">नमुना ई</h3>
          <p class="text-center text-xl fw-bold mt-3">
            कुटुंबनिवृत्ती वेतनासाठी नामनिर्देशन-१९६४
          </p>

          <div class="text-center pt-4">
            <p>
              दहा वर्षाच्या सेवासमाप्तीनंतर माझा मृत्यू झाल्यास शासनाकडून मंजूर
              करावयाचे कुटुंब निवृत्ती वेतन नियम 1964 अन्वये माझे कुटुंबीयांपैकी
              खालील उल्लेखलेल्या व्यक्तींना खालील प्रमाणे दर्शविण्यात आलेल्या
              क्रमाने मिळण्यास मी या द्वारे नामनिर्देशन करीत आहे
            </p>
          </div>
          <div class=" mt-3">
            <table class="table table-bordered text-sm">
              <thead>
                <tr class="table-heading">
                  <th>अ.क्र</th>
                  <th>नामनिर्देशित केलेल्या सदस्याचे नाव</th>
                  <th>कर्मचाऱ्याशी नाते</th>
                  <th>वय </th>
                  <th>विवाहित/अविवाहित</th>
                  <th>कार्यालय प्रमुखाची सही </th>
                  <th className="w-48 text-center">शेरा</th>
                </tr>
              </thead>
              <tbody>
                {familyMember.map((row, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td>{row.nameMr}</td>
                    <td>{row.relation}</td>
                    <td>{row.age}</td>
                    <td>{row.maritalStatus}</td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <p class="text-center pt-4">
            मी यापूर्वी दिनांक रोजी केलेले नामनिर्देशन अधिक्रमित करीत असून ते
            पूर्वीचे नामनिर्देशन रद्द झाले असे गृहित धरण्यात येईल.
          </p>

          <table class="table  text-center pb-5 pt-5">
            <thead>
              <tr>
                <th>स्वाहारी:</th>
                <th></th>
                <th>स्वाहारी:</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>नांव :</td>
                <td>..............</td>
                <td>नांव :</td>
                <td>..............</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>पद नाम:</td>
                <td>.............</td>
                <td> पद नाम:</td>
                <td>..............</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td>कार्यालय :</td>
                <td>..............</td>
                <td>कार्यालय :</td>
                <td>..............</td>
              </tr>
            </tbody>
          </table>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold">{formData && formData.fullName}</p>
              <p className="fw-bold">{formData && formData.designation}</p>
              <p className="fw-bold">{formData && formData.officeName}</p>
            </div>
          </div>

          <h4 class="fw-bold text-center border bg-secondary text-white text-xl mt-3 py-2">
            (कार्यालय प्रमुख / लेखा परिक्षा अधिकारी यांनी भरावयाचे )
          </h4>

          <div className="row align-items-center mt-4">
            <div className="col-lg-12 col-12">
              <p class="">
                निर्देशित करणा-या व्यक्तीचे नाव :
                <b className="fw-bold">
                  {formData && formData.fullName},{" "}
                  {formData && formData.designation}
                  {formData && formData.officeName}{" "}
                </b>
              </p>
            </div>
          </div>

          <div class="d-flex justify-content-evenly align-items-center pt-5 mt-5">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>
        </div>

        <div id="section5" className="commonClassTable border px-3 py-5">
          <h3 class="text-center highlight py-3 border mb-2">परिशिष्ट पाच</h3>
          <p class="text-center text-xl fw-bold mt-3">नमुना (५)</p>
          <p class="text-center text-xl fw-bold mt-3">
            (नियम १२१ (१) (सी) (१२३) (१) पहा)
          </p>

          <table class="table   mt-4">
            <tbody>
              <tr>
                <th>१</th>
                <th>कर्मचा-याचेसंपुर्ण नांव:</th>
                <th> ⇨ {formData && formData.fullName}</th>
              </tr>
              <tr>
                <th>अ.</th>
                <th>जन्म दिनांक </th>
                <th> ⇨ {formData && formData.birthDateNumber}</th>
              </tr>
              <tr>
                <th>ब. </th>
                <th>नियत वयोमानानुसार सेवा निवृत्ती दिनांक</th>
                <th> ⇨ {formData && formData.retirementDate}</th>
              </tr>
              <tr>
                <th>२</th>
                <th>
                  राजपत्रित शासकीय अधिकारी यांनी यथोचितरित्या
                  <br /> सांगितलेल्या दोन सहया (स्वतंत्र कागदावर)
                </th>
                <th> ⇨ सोबत सादर करण्यात आल्या आहेत</th>
              </tr>
              <tr>
                <th>३</th>
                <th>
                  पतीसह किंवा पत्नीसह काढलेल्या एकत्रित छायाचित्राच्या पारपत्र
                  <br /> आकाराच्या तीन प्रती, (कार्यालय प्रमुखाने साक्षांकित
                  केलेल्या असाव्यात)
                </th>
                <th> ⇨ सोबत सादर करण्यात आल्या आहेत.</th>
              </tr>
              <tr>
                <th>४</th>
                <th>
                  राजपत्रित शासकिय अधिकारी यांनी यथोचित रित्या साक्षांकित
                  <br /> केलेल्या उंची व वैयक्तिक ओळख चिन्हांचा तपशील दोन
                  <br /> चिठठया (स्वतंत्र कागदावर)
                </th>
                <th>⇨ सोबत सादर करण्यात आल्या आहेत.</th>
              </tr>
              <tr>
                <th>५</th>
                <th>सध्याचा पत्ता-</th>
                <td>⇨ {formData && formData.address}</td>
              </tr>
              <tr>
                <th>६</th>
                <th>निवृत्ती नंतरचा पत्ता-</th>
                <td>⇨ {formData && formData.address}</td>
              </tr>
              <tr>
                <th>७</th>
                <th>
                  जेथून निवृत्ती वेतन घ्यावयाचे आहे त्या शासकिय कोषागाराचे किंवा
                  सार्वजनिक बँकेच्या शाखेचे नाव.
                </th>
                <td>⇨ {formData && formData.officeToReceivePension}</td>
              </tr>
              <tr>
                <th>८</th>
                <th>नमुना तीनमध्ये कुटुं बाचा तपशील जोडण्यात याव</th>
                <td>⇨ सोबत सादर करण्यात आला आहे.</td>
              </tr>
            </tbody>
          </table>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold">{formData && formData.fullName}</p>
              <p className="fw-bold">{formData && formData.designation}</p>
              <p className="fw-bold">{formData && formData.officeName}</p>
            </div>
          </div>

          <div class="d-flex justify-content-evenly align-items-center pt-5 mt-5">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>
        </div>

        <div id="section6" className="commonClassTable border px-3 py-5">
          <h3 class="text-center highlight py-3 border mb-2">नमुना (६)</h3>
          <p class="text-center text-base fw-bold mt-3">
            (नियम १२०, १२२. १२३(१) व (३) आणि (१२७) पहा)
          </p>
          <p class="text-center text-base fw-bold mt-1">
            निवृत्ती वेतन उपदान निर्धारणासाठी नमुना
          </p>
          <p class="text-center text-base fw-bold mt-1">
            (दुस-या लेखापरिक्षा मंडव्यातून रक्कम प्रदान करावयाची असल्यास दोन पती
            पाठवाव्या.)
          </p>
          <table class="table w-100  mt-4">
            <tbody>
              <tr>
                <th>१</th>
                <th>शासकीय कर्मचाऱ्याचे नाव व पदनाम</th>
                <th>:-</th>
                <td>
                  {formData && formData.fullName},{" "}
                  {formData && formData.designation}
                </td>
              </tr>
              <tr>
                <th>२</th>
                <th>वडीलाचे / पतीचे संपूर्ण नाव</th>
                <th>:-</th>
                <td> {formData && formData.wifeHusbandName}</td>
              </tr>
              <tr>
                <th>३</th>
                <th>जन्मतारीख</th>
                <th>:-</th>
                <td> {formData && formData.birthDateNumber}</td>
              </tr>
              <tr>
                <th>४</th>
                <th>धर्म / जात</th>
                <th>:-</th>
                <td> {formData && formData.casteCategory}</td>
              </tr>
              <tr>
                <th>५</th>
                <th>गाव शहर जिल्हा राज्य दर्शविणारा पत्र व्यवहाराचा पत्ता</th>
                <th>:-</th>
                <td>{formData && formData.address}</td>
              </tr>

              <tr>
                <th>६</th>
                <th>सध्याचे नियुक्तीचे आस्थापनेचे नांव व पत्त</th>
                <th>:-</th>
                <td>{formData && formData.officeName}</td>
              </tr>
              <tr>
                <th>७</th>
                <th>सेवा सुरू झाल्याची तारीख</th>
                <th>:-</th>
                <td>
                  {formData && formData.appointmentDate}
                  {/* {formData && formData.appointmentDateWords}{" "} */}
                </td>
              </tr>
              <tr>
                <th>८</th>
                <th>सेवा समाप्तीची तारीख</th>
                <th>:-</th>
                <td>
                  {formData && formData.retirementDate}
                  {/* {formData && formData.appointmentDateWords}{" "} */}
                </td>
              </tr>
              <tr>
                <th>९</th>
                <th>
                  एक निवृत्ती वेतन किंवा उपदान मंजूर केलेला
                  <br /> में निकी सेवेचा एक ण कालावधी -
                </th>
                <th>:-</th>
                <td>:- लागू नाही</td>
              </tr>
              <tr>
                <th>१०</th>
                <th>
                  पूर्वीच्या नागरी सेवे बटल मिळालेल्या कोणत्याही
                  <br /> निवृत्ती वेतनाची व उपदानाची मिळालेली रक्कम व
                </th>
                <th>:-</th>
                <td>:- लागू नाही</td>
              </tr>
              <tr>
                <th>११</th>
                <th>नियतीच्या क्रमानुसार न्या शासनाची सेवा केली असेल</th>
                <th>:-</th>
                <td> {formData && formData.currentDistrict} </td>
              </tr>
              <tr>
                <td>12</td>
                <th> एकूण सेवेचा कालावधी:</th>
                <th>:-</th>
                <td>
                  <table class="table">
                    <tr>
                      <th>वर्ष</th>
                      <th>महिने</th>
                      <th>दिवस</th>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        {formData && formData.serviceDuration}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <th>१३</th>
                <th>लागू असलेला निवृत्ती वेतनाचा प्रकार</th>
                <th>:-</th>
                <td> {formData && formData.retirementType} </td>
              </tr>
              <tr>
                <th>१४</th>
                <th>कार्यवाही सुरू केल्याचा दिनांक</th>
                <th>:-</th>
                <td> 0</td>
              </tr>
              <tr>
                <th> अ</th>
                <th>
                  महाराष्ट्र नागरी सेवा निवृत्ती वेतन नियम १९८२ <br />
                  मधील नियम ११९ अन्वये संबंधित कार्यकारी
                  <br />
                  अभियंता यांच्याकडून नामागणी प्रमाणपत्र मिळविणे
                </th>
                <th>:-</th>
                <td> लागू नाही</td>
              </tr>
              <tr>
                <th>ब</th>
                <th>
                  महाराष्ट्र नागरी सेवा निवृत्ती वेतन नियम १९८२ <br />
                  मधील नियम १२१ अन्वये निवृत्ती वेतनाची <br />
                  अहंताकारी सेवा व वेतन निधर्धारित करणे.
                </th>
                <th>:-</th>

                <td>
                  <table class="table">
                    <tr>
                      <th>वर्ष</th>
                      <th>महिने</th>
                      <th>दिवस</th>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        {formData && formData.serviceDuration}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <th>क</th>
                <th>
                  {" "}
                  महाराष्ट्र नागरी सेवा निवृत्ती वेतन नियम १९८२ मधील नियम १३४{" "}
                  <br />
                  अन्वये शासकिय निवासस्थाना संबंधी
                  <br />
                  शासकिय रकमा व्यतिरिक्त इतर येणे रकमा महाराष्ट्र नागरी सवा नवा
                  वतन नियम १९८२ मधाल
                </th>
                <th>:-</th>
                <td>
                  <b>शासकिय निवासस्थान नियत करण्यात आलेले नाही</b>
                </td>
              </tr>
              <tr>
                <th>15</th>
                <th>
                  महाराष्ट्र नागरी सवा निवृता वतन नियम १९८२ मधील नियम १२२ अन्वये
                  हिशोबात न घेतलेल्या त्रुटी अपूर्णता व
                </th>
                <th>:-</th>
                <td>
                  <b> :- निरं क</b>
                </td>
              </tr>
              <tr>
                <th>16</th>
                <th>
                  अहंतकारी सेवेचा एकूण कालावधी बंदीत कालावधीची बेरीन करण्यासावै
                  समनण्यात येतो.
                </th>
                <th>:-</th>
                <td>
                  <b> :- निरं क</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="section61" className="commonClassTable border px-3 py-5">
          <table class="table w-100  mt-4">
            <tbody>
              <tr>
                <th>१७</th>
                <th>
                  अहे तकारी सेवेचा एकूण कालावध महाराष्ट्र नागरी सेवा निवृत्ती
                  वेतन नियम १९८२
                </th>
                <th>:-</th>
                <td>
                  <table class="table">
                    <tr>
                      <th>वर्ष</th>
                      <th>महिने</th>
                      <th>दिवस</th>
                    </tr>
                    <tr>
                      <td colSpan={3}>
                        {formData && formData.serviceDuration}
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <th> अ</th>
                <th>मधील नियम ४८ अन्वये सेवेतील कामापित केलेला बंद.</th>
                <th>:-</th>
                <td> :- निरं क</td>
              </tr>
              <tr>
                <th>ब</th>
                <th>
                  निवृत्ती वेतनासाठी अनहतंकारी म्हणून विशेषरित्या 21 केलेली
                  असाधारणरना
                </th>
                <th>:-</th>
                <td>निरं क</td>
              </tr>
              <tr>
                <th> क</th>
                <th>अर्हतकारी म्हणून न मानला नाणारा निलंबनाचा काला</th>
                <th>:-</th>
                <td> :- निरं क</td>
              </tr>
              <tr>
                <th>१८</th>
                <th>उपदानासावे नमेस धरलेले वेतनश्रेणी</th>
                <th>:-</th>
                <td>{formData && formData.salaryRange}</td>
              </tr>
              <tr>
                <th></th>
                <th>मूळ वेतन</th>
                <th>:-</th>
                <td>{formData && formData.baseSalary}</td>
              </tr>
              <tr>
                <th>१९</th>
                <th>
                  सरासरी निवृत्ती वेतनाच्या सेवेच्या मागील दहा महिन्याच्या
                  कालावधीतील सरासरी वेतन
                </th>
                <th>:-</th>
                <td> {formData && formData.avgTenMonthSalary}</td>
              </tr>
              <tr>
                <th colSpan={4}>
                  <table class="table table-bordered mt-4">
                    <thead>
                      <tr>
                        <th className="text-center">धारण केलेले पद </th>
                        <th className="text-center">पासून</th>
                        <th className="text-center">पर्यंत</th>
                        <th className="text-center">मूळवेतन</th>
                        <th className="text-center">महिने</th>
                        <th className="text-center">एकूण वेतन </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th className="text-center">१</th>
                        <th className="text-center">२</th>
                        <th className="text-center">३</th>
                        <th className="text-center">४</th>
                        <th className="text-center">५</th>
                        <th className="text-center">६</th>
                      </tr>
                      <tr>
                        <th className="text-center" rowSpan={2}>
                          {formData && formData.designation}
                        </th>
                        <th className="text-center"></th>
                        <th className="text-center"></th>
                        <th className="text-center">
                          {formData && formData.baseSalary}
                        </th>
                        <th className="text-center"></th>
                        <th className="text-center">
                          {formData && formData.baseSalary}
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center" colSpan={3}>
                          सरासरी निवृत्ती वेतनहार्य वेतन{" "}
                        </th>
                        <th colSpan={2} className="text-center">
                          {formData && formData.avgTenMonthSalary / 10}
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center" colSpan={2}>
                          शेवटच्या महिन्याचे वेतन माहे
                        </th>
                        <th className="text-center">
                          {formData && formData.retirementDate}
                        </th>
                        <th className="text-center">
                          {formData && formData.baseSalary}
                        </th>
                        <th className="text-center"></th>
                        <th className="text-center">
                          {formData && formData.baseSalary}
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </th>
              </tr>

              <tr>
                <th> २०</th>
                <th>१) प्रस्तावित सेवा निवृत्ती वेतन</th>
                <th>:-</th>
                <td>
                  {formData && formData.baseSalary} x 50%=
                  {formData && formData.baseSalary / 2}/-
                </td>
              </tr>
              <tr>
                <th></th>
                <th>२) निवृत्ती वेतनावरील उपदान</th>
                <th>:-</th>
                <td>
                  {formData && formData.baseSalary} * {serviceDurationMonth1} /
                  4 =
                  {Math.round(
                    (formData && formData.baseSalary * serviceDurationMonth1) /
                      4
                  ) || 0}
                </td>
              </tr>
              <tr>
                <th>२१</th>
                <th>निवृत्ती वेतनावरील उपदान</th>
                <th>:-</th>
                <td>
                  {Math.round(
                    (formData && formData.baseSalary * serviceDurationMonth1) /
                      4
                  ) || 0}
                </td>
              </tr>
              <tr>
                <th>२२</th>
                <th>निवृत्ती वेतन सुरु होणार असेल</th>
                <th>:-</th>
                <td>
                  {moment(formData && formData.retirementStartDate).format(
                    "DD-MMM-YYYY"
                  )}
                </td>
              </tr>
              <tr>
                <th>२३</th>
                <th>
                  तात्पुरत्या निवृत्ती वेतनाची प्रस्तावित रक्कम
                  <br />
                  (निवृत्ती पूर्वी शासकीय कर्मचान्याविरुध्द विभागीय किंवा
                  न्यायिक कार्यवाही दाखल असेल तर)
                </th>
                <th>:-</th>
                <td> निरं क</td>
              </tr>
              <tr>
                <th>२४</th>
                <th>
                  उपदानातून वसूल करावयाच्या शारानाच्या येणे <br />
                  रक्कम तपशील ज्या खाती जमा करावयाचे ते लेखाशिर्ष
                </th>
                <th>:-</th>
                <td> निरं क</td>
              </tr>
              <tr>
                <th> </th>
                <th>
                  अ) शासकीय निवासस्थान मिळाल्याचहल लायस-स फो महाराष्ट्र नागरी
                  सेवा निष्कृत्ती वेतन १९८२ मधील नियम १३३ चे पोट कलम (२) (३) व (
                  ४) पहा.
                </th>
                <th>:-</th>
                <td> निरं क</td>
              </tr>
              <tr>
                <th></th>
                <th>
                  ब) महाराष्ट्र नागरी सेवा निष्ठुत्ती वेतन नियम १९८२ मधील नियम
                  १३४ अन्वये उल्लेखिलेल्या येणे रकमा.
                </th>
                <th>:-</th>
                <td> निरं क</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div id="section62" className="commonClassTable border px-3 py-5">
          <table class="table w-100  mt-4">
            <tbody>
              <tr>
                <th> २५</th>
                <th>खालील वावीसावी नामनिर्देशन करण्यात आले आहे काय ?</th>
                <th>:-</th>
                <td> होय</td>
              </tr>
              <tr>
                <th> </th>
                <th>अ) लागू असल्यास कुटुंब निवृत्ती वेतन १९५०</th>
                <th>:-</th>
                <td> नाही</td>
              </tr>
              <tr>
                <th> </th>
                <th>ब) सेवानिवृत्ती उपदान / मृत्यू उपदान</th>
                <th>:-</th>
                <td> होय</td>
              </tr>
              <tr>
                <th> २६</th>
                <th>शासकीय कर्मचान्यारा वेतन १९६४ लागू आहे काय? असल्य</th>
                <th>:-</th>
                <td> होय</td>
              </tr>

              <tr>
                <th> </th>
                <th>अ) कुटुंब निवृत्ती वेतनासाठी जमेरा धरलेले वेतन</th>
                <th>:-</th>
                <td>{formData && formData.baseSalary}</td>
              </tr>
              <tr>
                <th> </th>
                <th>
                  ब) सेवा निवृत्ती नंतर शाराकिय कर्मचा-याचा मृत्यू झाल्यारा
                  कर्मचाऱ्याच्या कुटुंबाला देय होणारी कुटुंब निवृत्ती वेतनाचे
                  रक्कम..
                </th>
                <th>:-</th>
                <td> {formData && formData.baseSalary * 0.3}</td>
              </tr>
              <tr>
                <th></th>
                <th>क) वयाची ६५ वर्ष पूर्ण होण्यापूवी- :-</th>
                <th>:-</th>
                <td> {formData && formData.baseSalary / 2}</td>
              </tr>
              <tr>
                <th></th>
                <th>ड) वयाची ६५ वर्ष पूर्ण झाल्यानंतर</th>
                <th>:-</th>
                <td> {formData && formData.baseSalary * 0.3}</td>
              </tr>
              <tr>
                <th colSpan={4}>
                  <table class="table table-bordered mt-4">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>कुटुंबातील सदस्याचे नाव</th>
                        <th>जन्म तारीख</th>
                        <th>कर्मचा-याशी नाते</th>
                        <th>शेरा</th>
                      </tr>
                    </thead>
                    <tbody>
                      {familyMember.map((row, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{row.nameMr}</td>
                          <td>
                            {row.dob && moment(row.dob).format("DD-MMM-YYYY")}
                          </td>
                          <td>{row.relation}</td>
                          <td></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </th>
              </tr>

              <tr>
                <th>२७</th>
                <th>शासकीय कर्मचा-याची उंची -</th>
                <th>:-</th>
                <td> {formData && formData.height}</td>
              </tr>
              <tr>
                <th> २८</th>
                <th>शासकीय कर्मचा-याची ओळखचिन्हे</th>
                <th>:-</th>
                <td>
                  {formData && formData.identityMark1},{" "}
                  {formData && formData.identityMark2}
                </td>
              </tr>
              <tr>
                <th>२९</th>
                <th>
                  सेवानिवृत्ती वेतन घेण्याचे ठिकाण शासकीय कोषागार किवा सार्वजनिक
                  क्षेत्रातील बँकेच्या शाखेचे नाव.
                </th>
                <th>:-</th>
                <td>{formData && formData.officeToReceivePension}</td>
              </tr>
              <tr>
                <th> ३०</th>
                <th>निवृत्ती वेतन व उपदान खची घालण्याचे लेखाशिर्ष.</th>
                <th>:-</th>
                <td>१९ से.नि.वे. निवृत्ती वेतन व त्यावरील फायदे - 8</td>
              </tr>
            </tbody>
          </table>
          <p class="pt-3">
            ठिकाण :- {formData && formData.officeName}
            <br />
            दिनांक :-
          </p>
          <div class="d-flex justify-content-evenly align-items-center pt-5 mt-5">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>
        </div>

        <div id="section7" className="commonClassTable border px-4 py-4">
          <h3 class="text-center highlight py-3 border mb-2">नमुना (७)</h3>
          <p class="text-center fw-bold mt-2">( नियम १२३ (१) पहा )</p>
          <p class="text-center fw-bold mt-2">
            निवृत्ती वेतन उपदान निर्धारणासाठी नमुना
          </p>
          <p class="text-center fw-bold mt-2">
            ( शाराकिय कर्मचाऱ्याच्या निवृत्ती वेतनासंबंधिचे कागदपत्र पाठवतांना
            लेखापरिक्षा अधिका-याला लिहावयाच्या पत्राचा नमुना )
          </p>
          <div className="row mt-2">
            <div className="col-lg-7 col-md-7 col-7"></div>
            <div className="col-lg-5 col-md-5 col-5 ms-auto">
              <p className="fw-bold text-danger">
                {formData && formData.officeSerialNumber}
              </p>
              <p className="fw-bold text-danger">
                {formData && formData.officeName}
              </p>
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-1">प्रति,</p>
          <p className="fw-bold mt-1">मा. वरिष्ठ लेखाधिकारी </p>
          <p className="fw-bold text-danger mt-1">
            {formData && formData.currentDistrict}
          </p>

          <p className="fw-bold text-left mt-2">
            विषय :- निवृत्ती वेतन प्राधिकृत करण्यासाठी
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="mt-2">महोदय,</p>
          <p className="mt-1 textIndent">
            या विभागात{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            त्यांचे निवृत्ती वेतनाचे कागदपत्र आवश्यक त्यापुढील कार्यवाहीसाठी
            पाठविण्यात येत आहे. शाराकिय कर्मचाऱ्याच्या सेवानिवृत्तीच्या दिवशरी
            बाकी राहतील अशा आणि सेवानिवृत्ती उपदानाच्या रकमेतून वगुल करणे आवश्यक
            असलेल्या शासकीय येणे रकमेचा तपशील खालीलप्रमाणे दर्शविण्यात आला आहे.
          </p>

          <table className="table table-bordered border-1 border-black mt-2">
            <tbody>
              <tr>
                <th>अनु</th>
                <th>तपशील</th>
                <th>रक्कम रूपये</th>
              </tr>
              <tr>
                <td>1</td>
                <td>घरबांधणी किंवा वाहन आग्रीमाची शिल्लक रक्कम.</td>
                <td>निरंक</td>
              </tr>
              <tr>
                <td>2</td>
                <td>रजावेतनाराह वेतन व भत्ते अतिप्रदान केलेली रक्कम</td>
                <td>निरंक</td>
              </tr>
              <tr>
                <td>3</td>
                <td>
                  जायकर अधिनियम १९६१ अन्वये वेतनातून कपात करावयाची सायकर खकम
                </td>
                <td>निरंक</td>
              </tr>
              <tr>
                <td>4</td>
                <td>शासकिय निवासस्थान ताबा घेतल्याच्या लायरान्य फी थकबाकी.</td>
                <td>निरंक</td>
              </tr>
              <tr>
                <td>5</td>
                <td>
                  शासकिय निवारास्थान सेवा निवृत्तीच्या दिनांकानंतरही एक
                  महिण्याच्या कालावधीकरीता ठेवून घेतल्यावर लापरान्य फी थकबाकी
                  रक्कम.
                </td>
                <td>निरंक</td>
              </tr>
              <tr>
                <td>6</td>
                <td>
                  अनिधर्धारित येणे असल्यास त्याच्या समायोजनासाठी राखून ठेवलेल्या
                  उपदानाची रक्कम
                </td>
                <td>निरंक</td>
              </tr>
              <tr>
                <td> </td>
                <td>एकूण येणे रक्कम</td>
                <td>निरंक</td>
              </tr>
            </tbody>
          </table>
          <p class="mt-2">
            या विभागात{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांच्या विरूध्द विभागीय चौकशी प्रलंबित नान्नेले किवा ती करण्याचे
            योजीलेले नाही.
          </p>
          <div className="ps-5">
            <p class="mt-2">
              1) या पत्रासोबत पाठविण्यात आलेल्या राहपत्राची कृपया पोहच दयावी.
            </p>
            <p class="mt-2">
              २) या पोहच दयावी आणि निवृत्तीवेतनाच्या संवितरणासाठी संबंधित
              कोषागार अधिका-यांना आवश्यक त्या. सूचना दिल्या असल्याचे या विभागाला
              / कार्यालयाकडून या विभागाला कार्यालयाला कळवावे.
            </p>
            <p class="mt-2">
              ३) आपल्याकडून प्राधिकारपत्र मिळाल्यानंतर या विभागाकडून /
              सेवानिवृत्ती उपदान काढण्यात येईल व ते संवितरीत रयात येईल ही रकम
              देयापूर्वी वरील परिच्छेद न झालेल्या शासकीय येणे रक्कम
              मृत्यु-नि-रोवानिवृत्ती उपदानातून क्राल करण्यात येईल.
            </p>
          </div>

          <p class=" fw-bold mt-2">
            ठिकाण :- {formData && formData.officeName}
            <br />
            दिनांक :-
          </p>
          <div class="d-flex justify-content-evenly align-items-center pt-4 mt-4">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>
        </div>

        <div id="section8" className="commonClassTable border px-4 py-5">
          <h3 class="text-center highlight py-3 border mb-2">
            नमूना ५ चे सहपत्र
          </h3>

          <div className="container">
            <table className="table table-borderless border-0">
              <tbody>
                <tr>
                  <td className="w-64">
                    <p className="">
                      <b> निवृत्ती वेतनधारकाचे पारपत्र आकाराचे छायाचित्र</b>
                    </p>
                    <textarea
                      className="form-control bg-white"
                      rows={11}
                      readOnly
                    ></textarea>
                  </td>
                  <td className="pt-5 w-40">
                    <textarea
                      className="form-control bg-white"
                      rows={3}
                      readOnly
                    ></textarea>
                    <p>
                      {formData && formData.fullName},
                      {formData && formData.designation},{" "}
                      {formData && formData.officeName}
                    </p>
                    <textarea
                      className="form-control mt-3 bg-white"
                      rows={3}
                      readOnly
                    ></textarea>
                    <p>निवृत्ती वेतनधारकाचे वारसाची स्वाक्षरी</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <p className="mt-3 textIndent">
            प्रमाणित करण्यात येते की, वरील राही व छायाचित्र{" "}
            <b>
              {" "}
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            व त्यांची वारस पती / पत्नी{" "}
            <b>{formData && formData.wifeHusbandName}</b> आहे.
          </p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>

          <h3 class="text-center highlight py-3 border mt-5 mb-2">
            नमूना ५ चे सहपत्र
          </h3>

          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-12">
                <p className="mt-3">
                  अंगठा व बोटे यांच्या ठशांची चिठ्ठी{" "}
                  <b>
                    {formData && formData.fullName},
                    {formData && formData.designation},{" "}
                    {formData && formData.officeName}
                  </b>{" "}
                  यांची आहे.
                </p>
                <table class="table table-bordered mt-4 border-1 border-black ">
                  <thead>
                    <tr>
                      <th className="text-center">करंगळी</th>
                      <th className="text-center">अनामिका</th>
                      <th className="text-center">मधले बोट</th>
                      <th className="text-center">तर्जणी</th>
                      <th className="text-center">अंगठा</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="p-5"></td>
                      <td className="p-5"></td>
                      <td className="p-5"></td>
                      <td className="p-5"></td>
                      <td className="p-5"></td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  प्रमाणित करण्यात येते की, डाव्या हाताच्या अंगठ्याचे व बोटाचे{" "}
                  <b>
                    {" "}
                    {formData && formData.fullName},
                    {formData && formData.designation},{" "}
                    {formData && formData.officeName}
                  </b>{" "}
                  यांचे ठसे आहेत.
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section9" className="commonClassTable border px-4 py-5">
          <h3 class="text-center highlight py-3 border mb-2">
            नमूना ५ चे सहपत्र
          </h3>
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-12">
                <p className="mt-3">
                  अंगठा व बोटे यांच्या ठशांची चिठ्ठी{" "}
                  <b>
                    {formData && formData.fullName},
                    {formData && formData.designation},{" "}
                    {formData && formData.officeName}
                  </b>{" "}
                  यांची आहे.
                </p>
                <table class="table table-bordered mt-4 border-1 border-black ">
                  <thead>
                    <tr>
                      <th className="text-center">1</th>
                      <th className="text-center">2</th>
                      <th className="text-center">3</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="p-5"></td>
                      <td className="p-5"></td>
                      <td className="p-5"></td>
                    </tr>
                  </tbody>
                </table>
                <p>
                  प्रमाणित करण्यात येते की,
                  <b>
                    {" "}
                    {formData && formData.fullName},
                    {formData && formData.designation},{" "}
                    {formData && formData.officeName}
                  </b>{" "}
                  यांची नमुना स्वाक्षरी माझे समक्ष घेण्यात आली आहे.
                </p>
              </div>
            </div>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-8 col-8 col-md-8">
                <p className="fw-bold mt-3">
                  ठिकाण :- {formData && formData.officeName}
                </p>
                <p className="fw-bold mt-2">दिनांक :-</p>
              </div>

              <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>

          <h3 class="text-center highlight py-3 border mt-5 mb-2">
            नमूना ५ चे सहपत्र
          </h3>
          <div className="container mt-3">
            <div className="row align-items-center g-5">
              <div className="col-lg-12">
                <p>
                  <b>वर्णन पट --</b>
                </p>
                <div className="ps-5">
                  <p className="mt-2">
                    <b>१. उंची :- {formData && formData.height}"</b>
                  </p>
                  <p className="mt-2">
                    <b>
                      २. हात किंवा चेहऱ्यावर असलेल्या कोणत्याही वैयक्तिक खुणा --
                    </b>
                    <div className="ps-5">
                      <p className="mt-2">
                        {" "}
                        १){formData && formData.identityMark1}{" "}
                      </p>
                      <p className="mt-2">
                        {" "}
                        २){formData && formData.identityMark2}{" "}
                      </p>
                    </div>
                  </p>
                </div>
                <p className="mt-3">
                  प्रमाणित करण्यात येते की, वरील ओळख चिन्ह
                  <b>
                    {" "}
                    {formData && formData.fullName},
                    {formData && formData.designation},{" "}
                    {formData && formData.officeName}
                  </b>{" "}
                  यांचे आहे.
                </p>
              </div>
            </div>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-8 col-8 col-md-8">
                <p className="fw-bold mt-3">
                  ठिकाण :- {formData && formData.officeName}
                </p>
                <p className="fw-bold mt-2">दिनांक :-</p>
              </div>

              <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div id="section10" className="commonClassTable border px-4 py-4">
          <h3 class="text-center highlight py-3 border mb-2">नमूना (बी)</h3>
          <p class="text-center" colspan="2">
            (नियम ५ (२), १२, १३, १४ (१) आणि १५ (३) पहा)
          </p>
          <p class="text-center mt-3" colspan="2">
            निवृत्ती वेतन प्रदान देतांना निवृत्ती वेतनाच्या अंशराशीकृ त मूल्याचे
            प्रदान प्राधिकृत करण्यात यावे
          </p>
          <p class="text-center" colspan="2">
            अशी इच्छा असेल त्यावेळी वैद्यकीय तपासणी शिवाय नियतवयोमानाने /
            स्वेच्छा सेवानिवृत्तीने काही भागाचे अंशराशीकरण करण्यासाठी अर्जाचा
            नमुना
          </p>
          <p className="fw-bold text-center mt-3 text-sm">
            ( संवानिवृतीच्या तारखंपूर्वी किमान तीन महिन्याच्या आंत दाँत प्रती
            सादर कराव्यात)
          </p>
          <h3 class="text-center highlight py-2 border mb-2 w-75 m-auto">
            (भाग - १)
          </h3>
          <div className="container">
            <p className="fw-bold mt-3">प्रति,</p>
            <p className="fw-bold mt-1">मा. वरिष्ठ लेखाधिकारी </p>
            <p className="fw-bold text-danger mt-2">
              {formData && formData.currentDistrict}
            </p>

            <p className="fw-bold text-left mt-3">
              विषय :- वैदयकिय तपासणीशिवाय निवृत्ती वेतनाचे अंशराशीकरण
              {/* <b>
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b> */}
            </p>
            <p className="mt-3">महोदय,</p>
            <p className="mt-2 textIndent">
              महाराष्ट्र नागरी सेवा ( निवृत्तीवेतनाचे अंशराशीकरण ) नियम १९६४
              मधील तरतुदीनुसार खाली दर्शविण्यात आल्या प्रमाणं मला माझ्या काही
              भागाचं अंशराशीकरण करावयाचं आहे आवश्यक तपशील खालील प्रमाणे आहे
            </p>
            <table className="table table-borderless mt-3 border-0">
              <tbody>
                <tr>
                  <td>१</td>
                  <td>कर्मचा- पाचे संपूर्ण नाव</td>
                  <td>:-</td>
                  <td>{formData && formData.fullName}</td>
                </tr>
                <tr>
                  <td>२</td>
                  <td>वडीलाचे / पतीचे नाव (महिला कर्मचा-यांच्या पतीचे नांव)</td>
                  <td>:-</td>
                  <td>{formData && formData.wifeHusbandName}</td>
                </tr>
                <tr>
                  <td>३</td>
                  <td>सेवानिवृत्ती वेळेसचे पदनाम</td>
                  <td>:-</td>
                  <td>{formData && formData.designation}</td>
                </tr>
                <tr>
                  <td>४</td>
                  <td>जेथे काम करीत असेल त्या कार्यालयाचे विभागाचे नाव</td>
                  <td>:-</td>
                  <td>{formData && formData.officeName}</td>
                </tr>
                <tr>
                  <td>५</td>
                  <td>जन्मतारीख </td>
                  <td>:-</td>
                  <td>{formData && formData.birthDateNumber}</td>
                </tr>
                <tr>
                  <td>६</td>
                  <td>सेवा निवृत्तीची तारीख</td>
                  <td>:-</td>
                  <td>{formData && formData.retirementDate}</td>
                </tr>
                <tr>
                  <td>७</td>
                  <td>सेवा निवृत्तीचा प्रकार</td>
                  <td>:-</td>
                  <td>{formData && formData.retirementType}</td>
                </tr>
                <tr>
                  <td>८</td>
                  <td>
                    शासन निर्णय वित्त से निबे ५०० प्रक्र २३ संबा-४ दि३०.४०.०९
                    परिच्छेद ८.४
                  </td>
                  <td>:-</td>
                  <td>निवृत्ती वेतनाचे ४०%</td>
                </tr>
                <tr>
                  <td>९</td>
                  <td>अंशराशीकरण ४०% भाग रक्कम </td>
                  <td>:-</td>
                  <td>
                    {formData && formData.baseSalary} * 40% ={" "}
                    {formData && formData.baseSalary * 0.4}
                  </td>
                </tr>
                <tr>
                  <td>१०</td>
                  <td>निवृत्ती वेतन मंजूर प्राधिकाऱ्याचे नाव व पदनाम</td>
                  <td>:-</td>
                  <td>
                    उप मख्य लेखा व वित्त अधिकारी,
                    {formData && formData.currentDistrict}
                  </td>
                </tr>
                <tr>
                  <td>११</td>
                  <td>
                    सेवा निवृती जेथून सेवा निवृत्ती वेतन स्यात्रयाच त संवितरण
                    प्राधिकरण{" "}
                  </td>
                  <td>:-</td>
                  <td>वित्त विभाग, {formData && formData.currentDistrict}</td>
                </tr>
                <tr>
                  <td>A</td>
                  <td> कोषागार उपकोषागार</td>
                  <td>:-</td>
                  <td>{formData && formData.officeToReceivePension}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>उपकोषागाराचे नाव संपूर्ण पत्ता--</td>
                  <td>:-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>१)</td>
                  <td> राष्ट्रीयकृत बैंकेची शाखा व तिचा पूर्ण पत्ता-</td>
                  <td>:-</td>
                  <td></td>
                </tr>
                <tr>
                  <td>२)</td>
                  <td>मासिक निवृत्ती वेतन ज्या बैंक खात क्रमांकावर प्रत्येक</td>
                  <td>:-</td>
                  <td></td>
                </tr>
                <tr>
                  <td></td>
                  <td>महिन्यात जमा करावयाचा तो खाते क्रमांक--</td>
                  <td>:-</td>
                  <td></td>
                </tr>
              </tbody>
            </table>

            <div className="row mt-5 align-items-center">
              <div className="col-lg-8 col-8 col-md-8">
                <p className="fw-bold mt-3">
                  ठिकाण :- {formData && formData.officeName}
                </p>
                <p className="fw-bold mt-2">दिनांक :-</p>
              </div>

              <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
                <p className="fw-bold">
                  {formData && formData.fullName},
                  {formData && formData.designation}
                </p>
                <p className="fw-bold">{formData && formData.officeName}</p>
              </div>
            </div>
          </div>
        </div>

        <div id="section11" className="commonClassTable border px-4 py-5">
          <h3 class="text-center highlight py-2 border mb-2 w-75 m-auto">
            ( भाग - २ )
          </h3>

          <p className="mt-4 textIndent">
            <b>
              {" "}
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            वैद्यकीय तपासणीशिवाय निवृत्ती वेतनाच्या भागाचे अंशराशीकरण करण्या
            संबंधात नमुना बी भाग-१ मधील अर्ज मिळाला.
          </p>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-12 col-12 col-md-12">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>
          </div>

          <h3 class="text-center highlight py-2 border mt-5 mb-2 w-75 m-auto">
            ( भाग - ३ )
          </h3>
          <div className="container">
            <p className="fw-bold mt-3">प्रति,</p>
            <p className="fw-bold mt-2"> मा वरिष्ठ लेखाधिकारी,</p>
            <p className="fw-bold text-danger mt-2">
              {formData && formData.currentDistrict}
            </p>

            <p className="mt-3 textIndent">
              १. अर्जदाराने भाग-१ मध्ये दिलेला तपशील पडताळून पाहण्यात आला आणि तो
              बरोबर आहे -
            </p>
            <p className="mt-3 textIndent">
              वैद्यकीय तपासणीशिवाय निवृत्तीवेतनाच्या भागाचे अंशराशीकरण
              करण्यासंदर्भात अर्जदार पात्र आहे.{" "}
            </p>

            <p className="mt-3 textIndent">
              ३. सध्या लागू असलेल्या तक्त्यानुसार निर्धारित करण्यात आलेले
              निवृत्ती वेतन अंशराशिकृत मूल्य{" "}
              {formData && formData.baseSalary * 0.5 * 0.4} X{" "}
              {formData && formData.contributionValueAmt} X 12 =
              {Math.round(
                (formData && formData.baseSalary * 0.5 * 0.4) *
                  (formData && formData.contributionValueAmt) *
                  12
              ) || 0}
              /- इतके आहे.
            </p>

            <p className="mt-3 textIndent">
              ४. अंशराशीकरण केल्यानंतर अविशिष्ट निवृत्ती वेतनाची रक्कम रूपये
              {formData && formData.baseSalary * 0.3}.00 सर्व बाबतीत पूर्ण
              करण्यात आलेले अर्जदाराचे निवृत्तीवेतन विषयक कागदपत्र या विभागाचे
              पत्रक क्रमांक __________________ दिनांक _________________ अन्वये
              आपणकडे पाठविण्यात आलेले आहे निवृत्तीवेतन प्रदान आदेश देते वेळी
              निवृत्ती वेतनाच्या अंशराशीकृत मूल्याचे प्रदान प्राधिकृत करण्यात
              यावे व तो आदेश अर्जदाराच्या सेवानिवृत्ती वेतनाच्या एक महिन्यात
              देण्यात यावा अशी विनंती आहे.
            </p>
            <p>
              ५. या नमुन्यात भाग-१ व भाग-२ मध्ये देण्यासाठी अनुमती{" "}
              <b>
                {" "}
                {formData && formData.fullName},
                {formData && formData.designation},{" "}
                {formData && formData.officeName}
              </b>{" "}
              यांच्या कडे स्वतंत्ररित्या पाठविण्यात आली आहे निवृत्तीवेतनाचे
              अंशराशीकृत मूल्य वित्त विभागाखालील मागणी, निवृत्तीवेतन व इतर लाभ
              बी- निवृत्ती वेतनाचे अंशराशी कृत मूल्य या लेखाशिर्षाखाली खर्ची
              घालायचा आहे.
            </p>
          </div>

          <div className="row mt-5 align-items-center">
            <div className="col-lg-12 col-12 col-md-12">
              <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p>
            </div>
          </div>
          <div class="d-flex justify-content-evenly align-items-center pt-5 mt-5">
            <p class="text-sm">कार्यालय प्रमुख</p>
            <p class="text-sm">विभाग प्रमुख</p>
          </div>
        </div>

        <div id="section12" className="commonClassTable border px-4 py-5">
          <h3 class="text-center py-2 border mb-2 w-75 m-auto">
            • गृह कर्ज न घेतल्याबाबतचे प्रमाणपत्र •
          </h3>
          <div className="px-5 mt-4">
            <p className="textIndent">
              प्रमाणित करण्यात येते{" "}
              <b>
                {formData && formData.fullName},
                {formData && formData.designation}
              </b>{" "}
              यांनी गट विमा योजनेतून कोणतेही गृहकर्ज घेतलेले नाही. व त्यांचेकडे
              गृहकर्जाचे कोणते ही येणे बाकी नाही.
            </p>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-8 col-8 col-md-8">
                <p className="fw-bold mt-3">
                  ठिकाण :- {formData && formData.officeName}
                </p>
                <p className="fw-bold mt-2">दिनांक :-</p>
              </div>
              <div className="col-lg-4 col-4 col-md-4">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>

          <div class="certificate mt-5 pt-3">
            <h3 class="text-center py-2 border mb-2 w-75 m-auto">
              • गैरहजेरी/निलंबन/असाधारण रजा प्रकरण प्रलंबित नसल्याबाबतचे
              प्रमाणपत्र •
            </h3>
            <div className="px-5 mt-4">
              <p className="textIndent">
                प्रमाणित करण्यात येते{" "}
                <b>
                  {formData && formData.fullName},
                  {formData && formData.designation}
                </b>{" "}
                यांचे कोणतेही गैरहजेरी / निलंबन असाधारण रजा प्रकरण प्रलंबित
                नाही. करिता प्रमाणित करण्यात येत आहे.
              </p>
              <div className="row mt-5 align-items-center">
                <div className="col-lg-8 col-8 col-md-8">
                  <p className="fw-bold mt-3">
                    ठिकाण :- {formData && formData.officeName}
                  </p>
                  <p className="fw-bold mt-2">दिनांक :-</p>
                </div>
                <div className="col-lg-4 col-4 col-md-4">
                  <p className="fw-bold mt-3 text-center">
                    {formData && formData.officerDesignation}
                  </p>
                  <p className="fw-bold mt-1 text-center">
                    {formData && formData.officeName}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="certificate mt-5 pt-3">
            <h3 class="text-center py-2 border mb-2 w-75 m-auto">
              • विभागीय चौकशी चालू अथवा प्रस्तावित नसल्याबाबतचे प्रमाणपत्र •
            </h3>
            <div className="px-5 mt-4">
              <p className="textIndent">
                प्रमाणित करण्यात येते{" "}
                <b>
                  {formData && formData.fullName},
                  {formData && formData.designation}
                </b>{" "}
                यांचे कोणतेही विभागीय चौकशी चालू अथवा प्रस्तावित नाही. करिता
                प्रमाणित करण्यात येत आहे.
              </p>
            </div>
            <div className="row mt-5 align-items-center">
              <div className="col-lg-8 col-8 col-md-8">
                <p className="fw-bold mt-3">
                  ठिकाण :- {formData && formData.officeName}
                </p>
                <p className="fw-bold mt-2">दिनांक :-</p>
              </div>
              <div className="col-lg-4 col-4 col-md-4">
                <p className="fw-bold mt-3 text-center">
                  {formData && formData.officerDesignation}
                </p>
                <p className="fw-bold mt-1 text-center">
                  {formData && formData.officeName}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-4" id="button-section">
        <div className="col-lg-4 m-auto">
          <button
            className="btn btn-primary btn-lg w-100"
            onClick={() => generatePrintablePage()}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default PensionProposalPrint;
